<template>
  <router-link :to="routeObj"
               :is="disableButton ? 'span' : 'router-link'">
    <v-btn color="secondary" data-testid="viewAccountButton" type="button" x-small :disabled="disableButton">
      View
    </v-btn>
  </router-link>
</template>

<script>
  export default {
    name: 'ViewAccount',
    props: {
      account: Object
    },
    computed: {
      disableButton () {
        if (!this.account.id) {
          return true;
        }

        return false;
      },
      routeObj () {
        if (this.account.id) {
          if (this.account.Type == 'Policy' || this.account.AccountStatus == 'Bound' || this.account.AccountStatus == 'Submitted' || this.account.AccountStatus == 'Quoted') {
            return {
              path: '/account', query: { id: this.account.id }
            };
          } else {
            return {
              path: '/quote/quote', query: { id: this.account.id }
            };
          }
        }
        return {};
    }
    }
  };

</script>

<style scoped>
</style>
